export const messages = {
  es: {
    waiting_restaurant_confirmation: {
      state: 'Recibido',
      message: 'Hemos recibido tu pedido.'
    },
    waiting_for_external_payment: {
      state: 'Esperando pago externo',
      message: 'Estamos esperando la confirmación del pago.'
    },
    preparing_order: {
      state: 'Alistandose',
      message: 'El comercio esta preparando tu orden.'
    },
    already_restaurant: {
      state: 'Alistandose',
      message: 'Tu pedido está listo, ya puedes pasar por el presentando el código de la orden en el restaurante.'
    },
    delivering_order: {
      state: 'En camino',
      message: 'En el transcurso del día será entregado el pedido.'
    },
    order_completed: {
      state: 'Entregado',
      message: 'Gracias por Pedir en TodosComemos, te esperamos pronto!'
    },
    order_canceled_by_restaurant: {
      state: 'Cancelado por el Restaurante',
      message: 'El pedido ha sido cancelado por el restaurante. Por Favor haz tu pedido a otro restaurante.'
    },
    order_canceled_in_handoff: {
      state: 'Orden cancelada',
      message: 'Hemos cancelado tu pedido porque no apareciste. Esperamos no sigas jugando a las escondidas con nosotros.'
    },
    order_canceled_by_troubleshooting_delivery_man: {
      state: 'Orden cancelada',
      message: 'Hemos cancelado tu pedido por un problema con el estudiante que estaba llevando el pedido. Esperamos seguir mejorando para brindarte un mejor servicio.'
    },
    troubleshooting_restaurant: {
      state: 'Orden cancelada',
      message: 'El restaurante ha tenido un problema con tu orden y está intentando solucionarlo. Te notificaremos si el pedido es cancelado por el restaurante.'
    },
    troubleshooting_deliveryman: {
      state: 'Orden cancelada',
      message: 'El estudiante que está llevando tu pedido ha tenido un problema, te contactara prontamente o puedes contactarlo en los datos que se muestran de él.'
    },
    troubleshooting_hand_off: {
      state: 'Orden cancelada',
      message: 'El estudiante que tiene tu pedido te ha estado buscando y nada que te encuentra, por favor contactate con él.'
    },
    waiting_pickup_deliveryman: {
      state: 'Alistandose',
      message: 'El pedido está listo en el restaurante.'
    },
    order_not_generated: {
      state: 'Orden no generada',
      message: 'Se creó la orden pero no se generó el cobro.'
    }
  }
}
export default messages
